import moment from 'moment';

function formatCurrencyConversions(data) {
	return data.map((item) => ({
		...item,
		date: moment(item.date)
	}));
}

export default formatCurrencyConversions;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/currency-conversion-table/format-list.js